import { Dispatch, SetStateAction } from "react";
import EstablishmentNodeForm from "./EstablishmentNodeForm";


const EstablishmentNodeCreate = ({
  nextButtonFunction,
  setIsEstablishmentNodeInit,
  updateInterfaceData
}: EstablishmentNodeCreateProps) => {

  const initialValues: IEstablishmentNodeForm = {
    nodeID: ""
  }

  const handleSubmit =  (values: IEstablishmentNodeForm) => {
      updateInterfaceData(values);
      setIsEstablishmentNodeInit(true);
      nextButtonFunction();
  };
  
  return (
    <EstablishmentNodeForm 
      type={"create"} 
      initialValues={initialValues} 
      onSubmit={handleSubmit}    
    />
  )
}

export default EstablishmentNodeCreate;

type EstablishmentNodeCreateProps = {
  nextButtonFunction: () => void;
  setIsEstablishmentNodeInit: Dispatch<SetStateAction<boolean>>;
  updateInterfaceData: (data: Partial<IEstablishmentInterfaceForm>) => void;
}